import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

interface LottiePreviewProps {
  url: string;
}

const LottiePreview: React.FC<LottiePreviewProps> = ({ url }) => {
  return (
    <DotLottieReact
      src={url}
      loop
      autoplay
    />
  );
};

export default LottiePreview; 